<!-- 预付款申请数据操作 -->
<template>
  <div>
    <subComponents ref="showSelectData"></subComponents>
    <purchaseOrderTemplate ref="purchaseOrderTemplate"></purchaseOrderTemplate>
    <div>
      <div class="demo-drawer__content data_action_form">
        <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
          <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val)=>{showTabs=val}" @tabHeight="(val)=>{mxHeight=val}">
            <template slot="tabs" slot-scope="scope">
              <div class="table_content_box">
                <!-- 主要信息 -->
                <div v-if="scope.index == 0">
                  <el-form label-width="150px" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                    <el-row slot="" v-if="dataActionBox.actionType!=2">
                      <el-form-item v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" v-if="formOneValue.isShow==1" :key="formOneKey" :label="formOneValue.showField" :prop="formOneValue.entityField" :rules="formOneValue.isRequired == 1 ? [{required: formOneValue.isChange == 1,trigger: ['blur', 'change']}] : []">
                        <el-tooltip v-if="formOneValue.fieldType == 'search'" class="item" :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9" effect="dark"
        :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                        <el-input v-if="formOneValue.fieldType == 'search'" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField" @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField,formOneValue.setField)" :disabled="formOneValue.isChange == 0  || dataActionBox.actionType == 1">
                          <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField,formOneValue.setField)" slot="append" icon="el-icon-search" :disabled="formOneValue.isChange == 0  || dataActionBox.actionType == 1">
                          </el-button>
                        </el-input>
                        </el-tooltip>
                        <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                          <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.value" :value="item.key">
                          </el-option>
                        </el-select>
                        <df-date v-else-if="formOneValue.fieldType == 'date'" @keyup.enter.native="nextFocus(formOneKey)" :isShowLong="false" :isdisabled="formOneValue.isChange == 0" v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                        <el-input v-else :disabled="formOneValue.isChange == 0" @keyup.enter.native="nextFocus(formOneKey)" v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>
                      </el-form-item>
                    </el-row>
                    <el-row v-if="dataActionBox.actionType == 2">
                      <el-form-item :label="formOneValue.showField+':'" :prop="formOneValue.entityField" v-if="formOneValue.isShow==1" v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                        <span v-if="formOneValue.fieldType == 'date'">
                          {{$common.getLocalTime(sendDataInfo[formOneValue.entityField])}}</span>
                        <span v-else-if="formOneValue.isRift == 1">
                          <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{sendDataInfo[formOneValue.entityField]}}</a>
                        </span>
                        <span v-else>{{sendDataInfo[formOneValue.entityField]}}</span>
                      </el-form-item>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </template>
          </v-tabs>
        </el-card>
        <div style="margin-top:20px;text-align: center;">
          <div>
            <el-button v-if="dataActionBox.actionType==2" type="primary" @click="showPrintPlan">打印
            </el-button>
            <el-button type="primary" @click="initActionBox('sendDataInfo')" v-if="dataActionBox.actionType!=2">取消</el-button>
            <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType==0">保存</el-button>
            <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType==1">保存</el-button>
          </div>
        </div>
      </div>

    </div>
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
      <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
    <printPlan ref="printPlan"></printPlan>
  </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
  name: "supplierBankAction",
  props: ['actionData'],
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme,
  },
  data() {
    //这里存放数据
    return {
      dataActionBox: {
        showStatus: false,
        openMode: "ltr" || "rtl",
        boxTitle: "新增" || "编辑",
        actionType: 0, // 0新增，1修改
      },
      sendDataInfo: {
        "sbiAddress": "",
        "sbiCode": "",
        "sbiName": "",
        "sbiNumber": "",
        "sbiTelnumber": "",
        "smId": '',
        smName: '',
        isDefault: 0,
        remark: '',
        bankCode: "",
      },
      showTabs: "",
      formDataList: [],
      userOneList: [],
      seId: "",
      seWidth: "",
      height: "",
      seTitle: "",
      seWidth: "",
      DialogVisible: false,
      seType: "",
      smId: "",
      parentSearchData: {
        smId: "",
      },
      tables: false,
      mxHeight: 0,
      tabForm: [],
      mxForm: [],
      footForm: []
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {

  },
  //方法集合
  methods: {
    // 获取主表单所有input
    getMainInput() {
      var el = document.getElementById('mainInfo')
      if (el) this.inputel = el.getElementsByTagName('input')
    },
    // 初始化焦点
    initFocus() {
      for (let index = 0; index < this.inputel.length; index++) {
        if (this.inputel[index].value == '' && this.inputel[index].disabled == false) {
          this.inputel[index].focus()
          break
        }
      }
    },
    // 输入框切换焦点
    nextFocus(index) {
      if (index >= (this.inputel.length - 1)) return
      var aindex = index + 1
      if (this.inputel[aindex].value != '' || this.inputel[aindex].disabled) {
        this.nextFocus(aindex)
        return
      }
      this.inputel[aindex].focus()
    },
    showPrintPlan() { // 打印方法
      // 调用全局方法 判断Websocket是否连接
      if (this.$printSocketApi.printExeMsg() != false) {
        // 选中的数据
        this.$refs.printPlan.openDia(this.actionData.orderId, this.actionData.printSouce, this.actionData
          .printJurId)
      } else {
        return
      }
    },
    toDetail(orderId) {
      if (this.dataActionBox.actionType != 2) this.$parent.$parent.toDetail(orderId)
      else this.$parent.$parent.$parent.toDetail(orderId)
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    getWidth(e) {
      this.exWidth = e + "%";
    },
    getSearchName(e) {
      this.seTitle = e;
    },
    //检索Id, 索引(表格中), 标识
    openSearch(sId, index, type, sField) {
      this.DialogVisible = true;
      this.seId = sId;
      this.seIndex = index;
      this.seType = type;
      this.sField = sField;
      this.parentSearchData[type] = this.sendDataInfo[type]
    },
    // 赋值字段
    paramValue(val) {
      let arr = this.sField.split(',')
      arr.forEach(item => {
        this.sendDataInfo[item] = val[item]
      })
      this.$nextTick(() => {
        this.nextFocus(this.seIndex)
      })
    },
    changeInputModel(val) {
      if (val != "" || val != undefined) {
        this.DialogVisible = false;
        this.paramValue(val)
      }
    },

    initActionBox(sendDataInfo) {
      this.dataActionBox.actionType = 0;
      this.$emit('drawerCancel', 0)
      this.tables = false;
      this.init();
      this.$refs[sendDataInfo].resetFields();
    },
    init() {
      for (let key in this.sendDataInfo) {
        this.sendDataInfo[key] = "";
      }
      this.sendDataInfo.isDefault = 0;
    },


    openBox() {
      this.dataActionBox.actionType = this.actionData.cate
      this.formDataList = this.actionData.formData
      var oldData = this.actionData.oldData
      this.showTabs = this.actionData.formData[0].jciName
      this.filterMainField()
      this.init();
      if (this.dataActionBox.actionType == 0) {
        this.dataActionBox.boxTitle = "新增信息";
        this.dataActionBox.openMode = "ltr";
      } else if (this.dataActionBox.actionType == 1) {
        this.dataActionBox.boxTitle = "编辑信息";
        this.dataActionBox.openMode = "rtl";
        var dataInfo = JSON.parse(JSON.stringify(oldData));
        for (let key in dataInfo) {
          this.$set(this.sendDataInfo,key,dataInfo[key])
        }

      } else {
        this.tables = true
        this.dataActionBox.boxTitle = '查看信息'
        var dataInfo = JSON.parse(JSON.stringify(oldData))
        for (let key in dataInfo) {
          this.$set(this.sendDataInfo, key, dataInfo[key])
        }
      }
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.dataActionBox.actionType != 2) {
            this.mxHeight = this.$common.getBtnHeight()
          } else {
            this.mxHeight = this.$common.getHeight()
            this.initFocus();
          }
        }, 16.7)
      });
    },
    sendDataAction(sendDataInfo) {
      this.$refs[sendDataInfo].validate((valid) => {
        if (valid) {
          this.sub();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async sub() {
      let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
      if (this.dataActionBox.actionType == 0) {
        // 新增预付款
        var responseData = await this.$http.addSupBankinfo(sendData);
      } else {
        // 暂时没有编辑接口
        var responseData = await this.$http.updateSupBankinfo(sendData);
      }
      if (responseData.status == 200) {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.$emit('drawerCancel', 1)
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    // 过滤表单不同类型
    filterMainField() {
      var mainFormList = []
      this.formDataList.forEach(item => {
        if (item.jciType == 1) {
          mainFormList.push(item)
        } else if (item.jciType == 2) {
          this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
        } else if (item.jciType == 3) {
          this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
        }
      })
      mainFormList.forEach((key, i) => {
        this.tabForm[i] = JSON.parse(JSON.stringify(key))
        this.tabForm[i].jurconfigform = []
        this.tabForm[i].isShowForm = 0
        for (let index = 0; index < key.jurconfigform.length; index++) {
          if (key.jurconfigform[index].isShow == 1) this.tabForm[i].jurconfigform.push(key
            .jurconfigform[index])
        }
      })
      mainFormList[0].jurconfigform.forEach(item1 => {
        if (item1.fieldType == 'number') {
          this.$set(this.sendDataInfo, item1.entityField, 0)
        } else if (item1.fieldType == 'search' && item1.setField) {
          var arr = item1.setField.split(',')
          arr.forEach(item2 => {
            this.$set(this.sendDataInfo, item2, "")
          })
        } else {
          this.$set(this.sendDataInfo, item1.entityField, "")
        }
      })
      this.$set(this.sendDataInfo, "isDefault", 0)
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.$nextTick(() => {
      this.openBox()
    })
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() {
    this.getMainInput()
  }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
  height: 200px;
  background-color: red;
}

.table_content_box {
  /* height: 500px !important; */
  overflow-y: auto;
}

.el-row {
  display: flex;
  flex-wrap: wrap;
  padding-right: 20px;
}

.el-drawer {
  outline: none;
}

.mb {
  margin-bottom: 0;
}

.newInput {
  height: 28px;
  line-height: 28px;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  outline: 0;
  padding: 0 15px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
}
</style>